<template>
    <div class="home-view">
        <header class="home-header">
            <h1>¡Hola, {{ username || 'Usuario' }}!</h1>
            <button type="button" class="btn btn-danger logout-button" @click="openConfirmModal">
                Cerrar sesión
            </button>
        </header>

        <form id="logout-form" action="/logout" method="POST" style="display: none;">
            <input type="hidden" name="_token" :value="token" />
        </form>

        <div class="web-routes-container">
            <div class="general-web-routes superadmin-web-routes" v-if="canWatchSuperadminSection">
                <div>
                    <h3>ACCESOS RÁPIDOS PARA SUPERADMIN</h3>
                </div>
                <div class="general-web-routes-list superadmin-web-routes-list">
                    <HomeRouteButton v-for="route in superadminRoutes" :key="route.path" :href="route.path" :text="route.label.toUpperCase()"
                        v-if="route.permission" />
                </div>
            </div>
            <div class="general-web-routes user-web-routes" v-if="canWatchUserSection">
                <div>
                    <h3>ACCESOS RÁPIDOS PARA USUARIO</h3>
                </div>
                <div class="general-web-routes-list user-web-routes-list">
                    <HomeRouteButton v-for="route in userRoutes" :key="route.path" :href="route.path" :text="route.label.toUpperCase()"
                        v-if="route.permission" />
                </div>
            </div>
            <div class="general-web-routes machine-web-routes" v-if="canWatchMachineSection">
                <div>
                    <h3>ACCESOS RÁPIDOS PARA MÁQUINA</h3>
                </div>
                <div class="general-web-routes-list machine-web-routes-list">
                    <HomeRouteButton v-for="route in machineRoutes" :key="route.path" :href="route.path" :text="route.label.toUpperCase()"
                        v-if="route.permission" />
                </div>
            </div>
        </div>
        <transition name="slide-fade">
            <ActionConfirmModal
                v-if="showActionConfirmModal"
                :contentMessage="contentMessage"
                :closeModal="closeModal"
                :methodForProp="methodForProp"
            />
        </transition>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import HomeRouteButton from '../components/HomeRouteButton';
import PermissionsConsts from '../../common/permissions';
import ActionConfirmModal from '../../common/components/modals/ActionConfirmModal.vue';

export default {
    name: 'HomeView',
    components: {
        HomeRouteButton,
        ActionConfirmModal,
    },
    data() {
        return {
            token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            showActionConfirmModal: false,
            contentMessage: '',
            methodForProp: '',
        }
    },
    computed: {
        ...mapGetters(['userPermissions', 'userHasPermission','username', 'isUserSuperadmin']),
        machineRoutes() {
            return [
                { path: '/machine-selector', label: 'Pantalla de selección de máquinas', permission: this.userHasPermission(PermissionsConsts.PRODUCTION_MACHINE_SELECTOR_VIEW) }
            ];
        },
        userRoutes() {
            return [
                { path: '/monitorization', label: 'Monitorización de máquinas', permission: this.userHasPermission(PermissionsConsts.PRODUCTION_MONITORIZATION_VIEW) },
                { path: '/operator', label: 'Operarios', permission: this.userHasPermission(PermissionsConsts.OPERATOR_VIEW) },
                { path: '/operator-titles', label: 'Puestos de trabajo', permission: this.userHasPermission(PermissionsConsts.OPERATOR_TITLE_VIEW) },
                { path: '/users', label: 'Usuarios', permission: this.userHasPermission(PermissionsConsts.USER_INDEX_VIEW) },
                { path: '/calendar', label: 'Calendario', permission: this.userHasPermission(PermissionsConsts.CALENDAR_VIEW) },
                { path: '/calendar/shifts-templates', label: 'Plantillas de calendario', permission: this.userHasPermission(PermissionsConsts.SHIFT_TEMPLATE_INDEX_VIEW) },             
                { path: '/roles', label: 'Gestión de roles', permission: this.userHasPermission(PermissionsConsts.ROLES_INDEX_VIEW) },
                { path: '/order', label: 'Órdenes de producción', permission: this.userHasPermission(PermissionsConsts.PRODUCTION_ORDER_INDEX_VIEW) },
                { path: '/production-control', label: 'Control de producción', permission: this.userHasPermission(PermissionsConsts.PLANNER_PRODUCTION_CONTROL_VIEW) },
                { path: '/reporting/confection', label: 'Informes de confección', permission: this.userHasPermission(PermissionsConsts.REPORTING_CONFECTION_VIEW) },
                { path: '/production/about', label: 'Acerca de UMA', permission: this.userHasPermission(PermissionsConsts.HEADER_ABOUT_VIEW) },
                { path: '/configurations', label: 'Ajustes de capacidad productiva', permission: this.userHasPermission(PermissionsConsts.ADMIN_CONFIGURATIONS) },
                { path: '/reference', label: 'Artículos', permission: this.userHasPermission(PermissionsConsts.REFERENCE_VIEW) },
                { path: '/machine', label: 'Máquinas', permission: this.userHasPermission(PermissionsConsts.MACHINE_VIEW) }
            ];
        },
        superadminRoutes() {
            return [
                { path: '/production-line', label: 'Líneas de producción', permission: this.isUserSuperadmin },
                { path: '/permissions', label: 'Gestión de permisos', permission: this.isUserSuperadmin },
                { path: '/dataloggers', label: 'Dataloggers', permission: this.isUserSuperadmin },
                { path: '/configurations/superadmin', label: 'Configuración', permission: this.isUserSuperadmin },
            ];
        },
        canWatchMachineSection() {
            return this.machineRoutes.some(route => route.permission);
        },
        canWatchUserSection() {
            return this.userRoutes.some(route => route.permission);
        },
        canWatchSuperadminSection() {
            return this.superadminRoutes.some(route => route.permission) && this.isUserSuperadmin;
        }
    },
    methods: {
        logout() {
            const logoutForm = document.getElementById('logout-form');
            const tokenInput = document.createElement('input');
            tokenInput.type = 'hidden';
            tokenInput.name = 'authToken';
            tokenInput.value = CookieUtils.getCookie('AuthTokenValue');
            logoutForm.appendChild(tokenInput);

            CookieUtils.setCookie('AuthTokenValue', 'Sin token', 86400);

            logoutForm.submit();
        },
        openConfirmModal()
        {
            this.contentMessage = "¿Está seguro de que desea cerrar sesión?";
            this.methodForProp = this.logout;
            this.showActionConfirmModal = true;
        },
        closeModal() {
            this.showActionConfirmModal = false;
        },
    }
};
</script>
